import styled from "styled-components";

export const Container = styled.div`
  .wp-header {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    z-index: 99;
    &::before {
      content: "";
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background: rgba(255, 255, 255, 0.3);
      backdrop-filter: blur(60px);
      z-index: -1;
    }

    .header {
      max-width: 1080px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 60px;

      @media (max-width: 1366px) {
        padding: 0 25px;
      }

      .logo {
        cursor: pointer;
        @media (max-width: 540px) {
          img {
            max-height: 32px;
          }
        }
      }

      .menu {
        display: flex;
        align-items: center;

        &--item {
          font-family: "DM Sans";
          font-weight: 500;
          font-size: 18px;
          letter-spacing: 0.2px;
          text-transform: uppercase;
          margin-right: 65px;
          cursor: pointer;
          color: #5b5b5b;
          padding: 20px 0;
          position: relative;
          &:hover {
            .wp--sub__menu {
              display: flex;
            }
          }
          @media (max-width: 1024px) {
            margin-right: 40px;
            font-size: 16px;
          }
          .wp--sub__menu {
            position: absolute;
            top: 60px;
            display: none;
            gap: 65px;
            right: 0;
            justify-content: center;
            padding: 11px 0;
            z-index: 99;
            @media (max-width: 1600px) {
              padding-left: 6%;
            }
            @media (max-width: 1366px) {
              padding-left: 4%;
            }
            @media (max-width: 1024px) {
              padding-left: 28%;
            }
            @media (max-width: 900px) {
              padding-left: 18%;
            }
            &::before {
              content: "";
              position: fixed;
              left: 0;
              right: 0;
              top: 60px;
              height: 40px;
              /* bottom: 0; */
              background: rgba(255, 255, 255, 0.3);
              backdrop-filter: blur(60px);
            }

            .sub-menu {
              font-family: "DM Sans";
              font-weight: 400;
              font-size: 16px;
              position: relative;
              &::after {
                content: "";
                position: absolute;
                right: -32.5px;
                top: 0;
                width: 1px;
                height: 18px;
                background-color: ${(props) => props.theme.color.default};
              }
              &:last-child {
                &::after {
                  width: 0;
                }
              }
            }
          }
        }

        .select {
          position: relative;
          cursor: pointer;
          .content {
            background: ${(props) => props.theme.background.white};
            border: 1px solid #cfcfcf;
            border-radius: 2.42691px;
            padding: 5px 4px 3px 13px;
            max-height: 29px;
            width: 76px;
            line-height: 29px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-weight: 700;
            font-size: 14px;
            > div {
              padding-right: 5px;
            }
          }

          .option {
            border: 1px solid #cfcfcf;
            width: 76px;
            position: absolute;
            left: 0px;
            top: 28px;
            z-index: 2;
            > div {
              height: 29px;
              text-align: center;
              border-bottom: 1px solid #cfcfcf;
              background-color: ${(props) => props.theme.background.white};
              font-family: "DM Sans";
              font-weight: 700;
              font-size: 14px;
              line-height: 29px;
              &:last-child {
                border-bottom: none;
              }
            }
          }
        }
      }

      .box-mobile {
        img {
          cursor: pointer;
          @media (max-width: 540px) {
            max-width: 24px;
          }
        }

        .menu-mobile {
          position: fixed;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          letter-spacing: -0.015em;
          font-weight: 700;
          font-size: 25px;
          transform: translateX(100%);
          transition: transform 0.3s;
          z-index: 99;
          background: rgba(255, 255, 255, 0.3);
          height: 100vh;

          .item-menu__mobile {
            position: absolute;
            left: 30%;
            right: 0;
            top: 0;
            bottom: 0;
            background-color: ${(props) => props.theme.background.white};
            padding: 0 25px;
            letter-spacing: 0.002em;
            font-weight: 500;
            font-size: 17.5px;
            color: ${(props) => props.theme.color.default};

            > div {
              padding: 15px 0;
              cursor: pointer;
              font-family: "DM Sans";
              &:first-child {
                text-align: right;
                padding: 20px 0;
              }
            }

            .dropdown {
              > img {
                padding-left: 10px;
              }
              &--default {
                display: flex;
                align-items: center;
                justify-content: space-between;
                > div {
                  font-family: "DM Sans";
                }
                > img {
                  cursor: pointer;
                }
                .img-up {
                  transform: rotate(180deg);
                }
              }

              &--option {
                margin: 20px -25px 0;
                padding: 0 35px;
                background: ${(props) => props.theme.background.menuMobile};
                > div {
                  padding: 15px 0;
                  letter-spacing: 0.002em;
                  font-family: "DM Sans";
                  font-weight: 400;
                  font-size: 15.5px;
                }
              }
            }

            .icon-close {
              width: 17px;
              height: 17px;
              object-fit: cover;
            }
          }

          &__open {
            transform: translateX(0);
          }
        }

        .wp-lang {
          text-align: right;
          margin-top: 100%;
          display: flex;
          justify-content: flex-end;
          position: absolute;
          right: 35px;
          bottom: 80px;
          @supports (-webkit-overflow-scrolling: touch) {
            bottom: 120px;
          }

          .lang {
            letter-spacing: -0.03em;
            text-decoration-line: underline;
            font-family: "DM Sans";
            font-size: 17.449px;
            color: #a7a7a7;
            text-transform: uppercase;
            &:first-child {
              margin-right: 10px;
            }
          }
          .lang-active {
            font-weight: 700;
            color: ${(props) => props.theme.color.default};
          }
        }
      }
    }
  }
`;
